const e="v1",t={makePayments:"620",submitPaymentDetails:"621",submitThreeDS2Fingerprint:"622",createOrder:"623"};export{t as API_ERROR_CODE,e as API_VERSION};
